// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b75205a7","453":"35abec71","455":"43bb5e5d","977":"c3b9ef7f"}[chunkId] + ".chunk.js";
};